import { useEffect, useRef } from 'react';
import { Stack, useRouter, useSegments } from 'expo-router';
import * as Notifications from 'expo-notifications';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/lib/supabase';

export default function StudentLayout() {
  const { profile, loading } = useAuth();
  const router = useRouter();
  const segments = useSegments();
  const checked = useRef(false);

  useEffect(() => {
    if (loading || !profile || checked.current) return;
    if (segments.includes('onboarding') || segments.includes('waiting')) return;
    checked.current = true;
    supabase
      .from('students')
      .select('id, onboarding_completed, status')
      .eq('profile_id', profile.id)
      .order('id', { ascending: true })
      .limit(1)
      .then(({ data, error }) => {
        if (error) return;
        if (segments.includes('onboarding') || segments.includes('waiting')) return;
        // .limit(1) em vez de .single(): resiliente a students duplicado pro
        // mesmo profile_id (que com .single() travava a navegacao). order('id')
        // casa com a escolha da home. (Bug Jennifer 2026-06-05.)
        const row = data?.[0];
        if (row && !row.onboarding_completed) {
          router.replace('/(student)/onboarding' as any);
          return;
        }
        if (row && row.status !== 'active') {
          router.replace('/(student)/waiting' as any);
        }
      });
  }, [profile, loading, segments]);

  useEffect(() => {
    if (!profile) return;
    (async () => {
      try {
        const { status } = await Notifications.requestPermissionsAsync();
        if (status !== 'granted') return;
        const tokenObject = await Notifications.getExpoPushTokenAsync();
        await supabase.from('profiles').update({ expo_push_token: tokenObject.data }).eq('id', profile.id);
      } catch {}
    })();
  }, [profile?.id]);

  return (
    <Stack screenOptions={{ headerTintColor: '#C8102E', headerBackTitle: '' }}>
      <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
      <Stack.Screen name="onboarding" options={{ headerShown: false }} />
      <Stack.Screen name="waiting" options={{ headerShown: false }} />
      <Stack.Screen name="workout/[planId]" options={{ title: '' }} />
      <Stack.Screen name="chat" options={{ headerShown: false }} />
      <Stack.Screen name="profile" options={{ title: 'Meu Perfil' }} />
    </Stack>
  );
}
